$(document).ready(function () {
    $('.owl-cat').owlCarousel({
        loop: true,
        margin: 10,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsiveClass: true,
        nav: true,
        navText: ["<div class='d-none d-sm-block nav-btn prev-slide'><i class='fa fa-2x fa-chevron-left'></i></div>", "<div" +
        " class='d-none d-sm-block nav-btn next-slide'><i class='fa fa-2x fa-chevron-right'></i></div>"],
        responsive: {
            0: {
                items: 3,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 6,
            }
        }
    });

    $('.owl-one').owlCarousel({
        loop: true,
        margin: 10,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsiveClass: true,
        nav: false,
        navText: ["<div class='d-none d-sm-block nav-btn prev-slide'><i class='fa fa-2x fa-chevron-left'></i></div>", "<div" +
        " class='d-none d-sm-block nav-btn next-slide'><i class='fa fa-2x fa-chevron-right'></i></div>"],
        responsive: {
            0: {
                items: 2,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
                slideBy: 4
            }
        }
    });

    $('.owl-two').owlCarousel({
        items: 20,
        loop: true,
        margin: 10,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplayHoverPause: true,
        responsiveClass: true,
        nav: false,
        // navText: ["<div class='d-none d-sm-block nav-btn2 prev-slide'><i class='fa fa-2x fa-chevron-left'></i></div>", "<div" +
        // " class='d-none d-sm-block nav-btn2 next-slide'><i class='fa fa-2x fa-chevron-right'></i></div>"],
        responsive: {
            0: {
                items: 2,
                slideBy: 2
            },
            600: {
                items: 2,
                slideBy: 2
            },
            1000: {
                items: 4,
                slideBy: 4
            }
        }
    });
});
